import { useLocation } from "react-router-dom";
import ChatWidget from "@/components/ChatWidget";

// The chat widget is for visitors/clients — hidden on the internal admin dashboard.
export default function ConditionalChatWidget() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return <ChatWidget />;
}
